/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Share_Send_EmailInputs */

const cs_automation_share_send_email = /** @type {(inputs: Automation_Share_Send_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslat odkaz e-mailem`)
};

const en_automation_share_send_email = /** @type {(inputs: Automation_Share_Send_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send link by email`)
};

/**
* | output |
* | --- |
* | "Send link by email" |
*
* @param {Automation_Share_Send_EmailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_share_send_email = /** @type {((inputs?: Automation_Share_Send_EmailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Share_Send_EmailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_share_send_email(inputs)
	return cs_automation_share_send_email(inputs)
});